import React, { useState, useEffect } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const ServiceTestimonials = ({ testimonials, serviceName }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => handleNext(), 5000);
    return () => clearInterval(interval);
  }, [currentIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setTimeout(() => setIsAnimating(false), 400);
  };
  const handlePrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setTimeout(() => setIsAnimating(false), 400);
  };

  return (
    <section className="py-20 bg-[#F4F4F5]" data-testid="service-testimonials">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">Client Stories</p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}}>What Our Clients Say</h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <Card className="bg-white border border-zinc-200 shadow-sm rounded-lg">
            <CardContent className="pt-8 pb-8 px-8">
              <p className="text-zinc-600 text-sm leading-relaxed mb-6">"{testimonials[currentIndex].text}"</p>
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (<Star key={i} className="w-4 h-4 fill-[#002FA7] text-[#002FA7]" />))}
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-md bg-[#002FA7] text-white flex items-center justify-center font-bold text-sm" style={{fontFamily:'Outfit,sans-serif'}}>{testimonials[currentIndex].name.charAt(0)}</div>
                <div>
                  <div className="font-semibold text-[#09090B] text-sm">{testimonials[currentIndex].name}</div>
                  <div className="text-xs text-zinc-500">{testimonials[currentIndex].role}</div>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="flex items-center justify-center gap-4 mt-6">
            <Button onClick={handlePrev} disabled={isAnimating} className="bg-[#002FA7] hover:bg-[#001D66] text-white rounded-md w-9 h-9 p-0"><ChevronLeft className="w-4 h-4" /></Button>
            <div className="flex items-center gap-1.5">
              {testimonials.map((_, index) => (
                <button key={index} onClick={() => { if (!isAnimating) { setIsAnimating(true); setCurrentIndex(index); setTimeout(() => setIsAnimating(false), 400); }}}
                  className={`transition-all duration-300 rounded-full ${index === currentIndex ? 'w-5 h-1.5 bg-[#002FA7]' : 'w-1.5 h-1.5 bg-zinc-300 hover:bg-[#002FA7]/50'}`} />
              ))}
            </div>
            <Button onClick={handleNext} disabled={isAnimating} className="bg-[#002FA7] hover:bg-[#001D66] text-white rounded-md w-9 h-9 p-0"><ChevronRight className="w-4 h-4" /></Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceTestimonials;
